import { allFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
export class FirestoreEducationalDomainsRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    async getAllDomains() {
        const snapshot = await this.db.internalAccountsEducationalDomainsCollection().get();
        return allFromSnapshot(snapshot);
    }
    async getDomainByUid(domainUid) {
        const doc = await this.db.internalAccountsEducationalDomainsCollection().doc(domainUid).get();
        return doc.exists ? doc.data() : undefined;
    }
    async addDomain(domain) {
        await this.db.internalAccountsEducationalDomainsCollection().doc(domain.uid).set(domain);
    }
    async updateDomain(domainUid, updates) {
        await this.db.internalAccountsEducationalDomainsCollection().doc(domainUid).set(updates, { merge: true });
    }
    async deleteDomain(domainUid) {
        await this.db.internalAccountsEducationalDomainsCollection().doc(domainUid).delete();
    }
    subscribeToEducationalDomains(onReceive, onDelete, onError) {
        return this.db.internalAccountsEducationalDomainsCollection().onSnapshot((snapshot) => {
            const addedOrChanged = [];
            const removed = [];
            for (const change of snapshot.docChanges()) {
                const data = change.doc.data();
                if (change.type === "removed") {
                    removed.push(data);
                }
                else {
                    addedOrChanged.push(data);
                }
            }
            if (addedOrChanged.length > 0) {
                onReceive(addedOrChanged);
            }
            if (removed.length > 0) {
                onDelete(removed);
            }
        }, (error) => {
            onError(error);
        });
    }
}
//# sourceMappingURL=FirestoreEducationalDomainsRepository.js.map